// extracted by mini-css-extract-plugin
export var container = "ContentWrapper-module--container--D9NIy";
export var inner = "ContentWrapper-module--inner--1heeU";